<template>
  <div
    class="analysts-edit"
  >
    <page-header :header="channel ? `Create Analyst - ${channel.name}` : 'Create Analyst'" />
    <analyst-form
      ref="form"
      class="mt-3"
      :channel="channel"
      @save-success="saveSuccess"
    />

    <div class="d-flex w-100 border-top pt-4">
      <button
        class="ml-auto btn btn-primary "
        type="button"
        @click="$refs.form.save()"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import AnalystForm from './Form'
import {get} from '@/helpers'
import {successNotification} from '@/notifications'

export default {
  components: {
    AnalystForm,
  },
  data () {
    return {

      channel: null,
    }
  },
  metaInfo () {
    return {
      title: 'Analysts',
    }
  },
  activated () {
    const channelId = this.$route.query.channel_id
    if (channelId) {
      get(`channels/${channelId}`).then((channel) => {
        this.setChannel(channel.data.data)
      })
    } else {
      this.setChannel(null)
    }
  },

  methods: {
    setChannel (channel) {
      this.channel = channel
    },
    saveSuccess (response) {
      this.$notify(successNotification('Created analyst successfully'))

      this.$router.replace({
        name: 'analysts.view',
        params: {
          analystId: response.data.data.id,
        },
      })
    },

  },
}
</script>
